import type { Cache, ResolveInfo } from '@urql/exchange-graphcache';
import { EVENT_PERSON_CACHE_FIELDS } from '@/client/exchanges/cacheExchange/constants';
import invalidateFields, {
  type FieldInvalidationCache,
} from '@/client/exchanges/cacheExchange/invalidateFields';

export function invalidateEventPersonFields(cache: FieldInvalidationCache) {
  invalidateFields(EVENT_PERSON_CACHE_FIELDS, cache);
}

export default function delete_event_person(
  _parent: unknown,
  _args: unknown,
  cache: Cache,
  _info: ResolveInfo,
) {
  invalidateEventPersonFields(cache);
}
